import { createFileRoute } from "@tanstack/react-router"
import { VideoDebugPageWrapper } from "./-DebugPage"

export const Route = createFileRoute("/videos/$videoId/debug")({
  component: VideoDebugPageWrapper,
})
